import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=25dd1dd3&"
import script from "./Icon.js?vue&type=script&lang=js&"
export * from "./Icon.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dd1dd3')) {
      api.createRecord('25dd1dd3', component.options)
    } else {
      api.reload('25dd1dd3', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=25dd1dd3&", function () {
      api.rerender('25dd1dd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Icon/Icon.vue"
export default component.exports